export default __webpack_public_path__ + "static/2140-733c06eddd9a101a0ab176e980c7ee59.gif";